<!-- Wizard Container -->
<div class="wizard-container">
  <h2 class="text-center mb-4">Nueva Entrega de Piensos</h2>

  <!-- Indicador de progreso -->
  <div class="progress mb-4" *ngIf="pasos.length > 0">
    <div
      class="progress-bar"
      role="progressbar"
      [style.width.%]="(pasoActual / pasos.length) * 100"
      [attr.aria-valuenow]="pasoActual"
      aria-valuemin="1"
      [attr.aria-valuemax]="pasos.length"
    >
      Paso {{ pasoActual }} de {{ pasos.length }}
    </div>
  </div>

  <!-- Paso Finca -->
  <div *ngIf="pasos[pasoActual - 1]?.tipo === 'finca'" class="step-content">
    <h3 class="mb-3">1. Finca de Destino</h3>

    <div class="form-group">
      <label for="finca">Indique la finca de la entrega:</label>
      <select
        class="form-control"
        id="finca"
        [(ngModel)]="entregaData.finca"
        required
      >
        <option value="" disabled selected>Seleccione una finca...</option>
        <option *ngFor="let f of fincas" [value]="f.ttcodexp">
          {{ f.ttdescr }} - {{ f.ttpoblac }} - {{ f.ttcodexp }}
        </option>
      </select>
    </div>

    <div class="d-flex justify-content-end mt-4">
      <button
        class="btn btn-primary"
        (click)="siguientePaso()"
        [disabled]="!fincaValida()"
      >
        Siguiente <fa-icon [icon]="faArrowRight"></fa-icon>
      </button>
    </div>
  </div>

  <!-- Paso Piensos (uno por cada marca) -->
  <div *ngIf="pasos[pasoActual - 1]?.tipo === 'pienso'" class="step-content">
    <h3 class="mb-3">
      {{ pasos[pasoActual - 1].marca.ttdesmar }}
    </h3>

    <div
      *ngFor="let tipo of pasos[pasoActual - 1].marca.tipos"
      class="row align-items-center mb-2"
    >
      <div class="col-sm-6">{{ tipo.ttdestip }}</div>
      <div class="col-sm-6">
        <input
          type="number"
          class="form-control"
          [(ngModel)]="tipo.cantidad"
          min="0"
        />
      </div>
    </div>

    <div class="d-flex justify-content-between mt-4">
      <button class="btn btn-secondary" (click)="anteriorPaso()">
        <fa-icon [icon]="faArrowLeft"></fa-icon> Anterior
      </button>
      <button class="btn btn-primary" (click)="siguientePaso()">
        Siguiente <fa-icon [icon]="faArrowRight"></fa-icon>
      </button>
    </div>
  </div>

  <!-- Paso Formato -->
  <div *ngIf="pasos[pasoActual - 1]?.tipo === 'formato'" class="step-content">
    <h3 class="mb-3">Formato de Entrega</h3>

    <div class="form-check">
      <input
        class="form-check-input"
        type="radio"
        name="formato"
        id="granel"
        [checked]="entregaData.formato === 'granel'"
        (change)="seleccionarFormato('granel')"
      />
      <label class="form-check-label" for="granel">Granel</label>
    </div>
    <div class="form-check">
      <input
        class="form-check-input"
        type="radio"
        name="formato"
        id="envasado"
        [checked]="entregaData.formato === 'envasado'"
        (change)="seleccionarFormato('envasado')"
      />
      <label class="form-check-label" for="envasado">Envasado</label>
    </div>

    <div class="d-flex justify-content-between mt-4">
      <button class="btn btn-secondary" (click)="anteriorPaso()">
        <fa-icon [icon]="faArrowLeft"></fa-icon> Anterior
      </button>
      <button class="btn btn-primary" (click)="siguientePaso()">
        Siguiente <fa-icon [icon]="faArrowRight"></fa-icon>
      </button>
    </div>
  </div>

  <!-- Paso Observaciones + Fecha -->
  <div
    *ngIf="pasos[pasoActual - 1]?.tipo === 'observaciones'"
    class="step-content"
  >
    <h3 class="mb-3">Observaciones y Fecha</h3>

    <div class="form-group">
      <label for="observaciones">Observaciones:</label>
      <textarea
        class="form-control"
        id="observaciones"
        [(ngModel)]="entregaData.observaciones"
        rows="2"
      ></textarea>
    </div>

    <div class="form-group mt-3">
      <label for="fechaEntrega">Fecha de Entrega:</label>
      <input
        type="date"
        class="form-control"
        id="fechaEntrega"
        [(ngModel)]="entregaData.fecha"
        required
      />
    </div>

    <div class="d-flex justify-content-between mt-4">
      <button class="btn btn-secondary" (click)="anteriorPaso()">
        <fa-icon [icon]="faArrowLeft"></fa-icon> Anterior
      </button>
      <button
        class="btn btn-success"
        (click)="enviarEntrega()"
        [disabled]="resul"
      >
        <span *ngIf="!resul">Enviar Entrega</span>
        <span *ngIf="resul">
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Enviando...
        </span>
      </button>
    </div>
  </div>
</div>
<!-- /wizard-container -->

<div class="separador"></div>
<div style="text-align: center">
  <div *ngIf="resul" class="spinner-border text-primary" role="status">
    <span class="sr-only">Enviando...</span>
  </div>
</div>
